// extracted by mini-css-extract-plugin
export var black = "_4k-6";
export var brand = "_4k-1";
export var ddefault = "_4k-0";
export var error = "_4k-3";
export var gray = "_4k-2";
export var highContrast = "_4k-8";
export var outline = "_4k-7";
export var success = "_4k-5";
export var warning = "_4k-4";